export default __webpack_public_path__ + "static/MediaContentTwo-cc14896425a942240d5ca36620708357.webp";